import Macy from "macy";
import { GLOBAL_CONSTANTS } from "../../globals/constants";
import { EventBus } from "../../globals/emitter";
import { autobind } from "core-decorators";
import { isMobile } from "../../globals/functions";

const classes = {
  BlogRollContainer: ".js-blog-roll-container",
};

/**
 * @desc Macy.js is a lightweight dependency-free JavaScript library designed to sort items vertically into columns
 * by finding an optimum layout with a minimum height.
 */
export class CrosslinkGrid {
  $el: HTMLElement;
  grid: typeof Macy;
  isActive = false;
  $blogRollContainer: HTMLElement;

  constructor(el: HTMLElement) {
    this.$el = el;
    this.$blogRollContainer = this.$el.querySelector(
      classes.BlogRollContainer,
    ) as HTMLElement;

    setTimeout(() => {
      this.grid = Macy({
        container: ".js-crosslink-grid__container",
        trueOrder: false,
        waitForImages: false,
        margin: 24,
        columns: 3,
        breakAt: {
          1200: 3,
          940: 2,
          520: 1,
        },
      });

      this.isActive = true;
      this.bindEvents();
      this.checkIfGridIsValid();

      const classGrid = this.grid;
      classGrid.runOnImageLoad(() => {
        classGrid.recalculate(true);
      }, true);
    }, 0);
  }

  bindEvents() {
    EventBus.on(GLOBAL_CONSTANTS.EVENTS.ADJUST_GRID, this.adjustGrid);
    EventBus.on(GLOBAL_CONSTANTS.EVENTS.RESIZE, this.checkIfGridIsValid);
    EventBus.on(GLOBAL_CONSTANTS.EVENTS.SCROLL, this.checkIfGridIsValid);
  }

  @autobind
  adjustGrid() {
    if (this.isActive) {
      this.grid.recalculate(true);

      // **
      // ***   Macy not recalculating/resizing on initial call on BlogRoll - have to call it twice
      // **
      if (this.$blogRollContainer) {
        this.grid.recalculate(true);
      }
    }
  }

  @autobind
  checkIfGridIsValid() {
    if (isMobile()) {
      this.grid.remove();
      this.isActive = false;
    } else if (!this.isActive) {
      this.grid.reInit();
      this.isActive = true;
    } else {
      this.adjustGrid();
    }
  }

  /**
   * @desc Remove click events on triggers
   */
  tearDown(): void {
    EventBus.off(GLOBAL_CONSTANTS.EVENTS.ADJUST_GRID, this.adjustGrid);
  }
}
